// Adds the Spring Security CSRF header (from the <meta> tags in <head>) to
// every htmx request. Harmless where htmx isn't loaded: the event never fires.
export function initHtmxSetup() {
    document.addEventListener('htmx:configRequest', e => {
        const token  = document.querySelector('meta[name="_csrf"]')?.content;
        const header = document.querySelector('meta[name="_csrf_header"]')?.content;
        if (token && header) e.detail.headers[header] = token;
    });
}